import React, { Component } from 'react';
import { connect } from 'react-redux';
import qs from 'qs';

import ButtonBase from 'material-ui/ButtonBase';
import CheckIcon from '@material-ui/icons/Check';
import ClockIcon from '@material-ui/icons/Schedule';
import UnpublishedIcon from '@material-ui/icons/Block';
import Tooltip from 'material-ui/Tooltip';

import { FEATURES } from '../../../v5/features/components/constants';
import { getState, getStore } from '../../../state/store';
import openCalendarMessagingSummaryDrawer from '../../../v5/messaging/state/openCalendarMessagingSummaryDrawer';
import * as CalendarState from '../../../state/reducer/calendar/calendar';
import * as FeedState from '../../../state/reducer/feed/feed';
import * as SummaryState from '../../../state/reducer/summary/summary';
import * as Icon from '../../../lib/icons/SvgIcon';
import * as Utils from '../../../lib/designerUtils';

import * as ProgramTypes from '../../../state/reducer/calendar/programTypes';
import Console from '../../../lib/debug';
import CommentBubble from '../../../v5/messaging/components/CommentBubble';

export class SummaryHeaderClass extends Component {
    componentDidMount() {
        if (this.props.inDrawer || !this.props.session) {
            return;
        }

        const search = qs.parse(window.location.search.replace('?', ''));

        if (
            !search ||
            !search.workoutId ||
            parseInt(search.workoutId) !== this.props.session.workout_id
        ) {
            return;
        }
        this.showFeedDrawer();
    }

    getComplianceSingle() {
        let session = this.props.session;
        let sessionDate = new Date(
            session.year,
            session.month - 1,
            session.day
        ).setHours(0, 0, 0, 0);
        let today = new Date().setHours(0, 0, 0, 0);
        let percentage = 0;
        let blocks = [];
        let completedBlocksCount = 0;

        let compliance = {};

        if (Object.keys(this.props.summaryBlocks).length >= 1) {
            if (this.props.session.setKeys) {
                for (let i = 0; i < this.props.session.setKeys.length; i++) {
                    if (
                        this.props.summaryBlocks[this.props.session.setKeys[i]]
                    ) {
                        blocks.push(
                            this.props.summaryBlocks[
                                this.props.session.setKeys[i]
                            ]
                        );
                    } else {
                        blocks.push(
                            this.props.blocks[this.props.session.setKeys[i]]
                        );
                    }
                }
            } else {
                for (
                    let i = 0;
                    i < this.props.session.workoutSets.length;
                    i++
                ) {
                    if (
                        this.props.summaryBlocks[
                            this.props.session.workoutSets[i].id
                        ]
                    ) {
                        blocks.push(
                            this.props.summaryBlocks[
                                this.props.session.workoutSets[i].id
                            ]
                        );
                    } else {
                        blocks.push(
                            this.props.blocks[
                                this.props.session.workoutSets[i].id
                            ]
                        );
                    }
                }
            }

            session.totalBlocks = blocks.length;
            for (let j = 0; j < blocks.length; j++) {
                let block = blocks[j];
                if (block && block.completed === 1) {
                    completedBlocksCount++;
                }
            }
            if (session.totalBlocks !== 0) {
                percentage = Math.round(
                    (completedBlocksCount / session.totalBlocks) * 100
                );
            } else {
                percentage = 0;
            }
        } else {
            if (this.props.session.setKeys) {
                for (let i = 0; i < this.props.session.setKeys.length; i++) {
                    blocks.push(
                        this.props.blocks[this.props.session.setKeys[i]]
                    );
                }
            } else {
                for (
                    let i = 0;
                    i < this.props.session.workoutSets.length;
                    i++
                ) {
                    blocks.push(
                        this.props.blocks[this.props.session.workoutSets[i]]
                    );
                }
            }

            session.totalBlocks = blocks.length;

            for (let j = 0; j < blocks.length; j++) {
                let block = blocks[j];
                if (block && block.completed === 1) {
                    completedBlocksCount++;
                }
            }
            if (session.totalBlocks !== 0) {
                percentage = Math.round(
                    (completedBlocksCount / session.totalBlocks) * 100
                );
            } else {
                percentage = 0;
            }
        }

        if (sessionDate === today) {
            if (Object.keys(this.props.summaryBlocks).length >= 1) {
                compliance.value =
                    completedBlocksCount + '/' + session.totalBlocks;
                compliance.completedAthleteCount = 1;
                if (percentage < 50) {
                    compliance.color = 'black';
                } else {
                    compliance.color = 'green';
                }

                if (percentage === 100) {
                    compliance.icon = Icon.getIcon(Icon.TYPE.PIE100, 'green');
                } else if (percentage === 0) {
                    compliance.icon = Icon.getIcon(
                        Icon.TYPE.PIE0,
                        compliance.color
                    );
                } else {
                    let iconName = 'pie-' + this.getPieIconValue(percentage);
                    compliance.icon = Icon.getIcon(iconName, compliance.color);
                }
            } else {
                compliance.color = 'black';
                compliance.icon = Icon.getIcon(
                    Icon.TYPE.PIE0,
                    compliance.color
                );
                compliance.completedAthleteCount = 0;
                compliance.value = '0/' + session.totalBlocks;
            }
        } else if (sessionDate < today) {
            //if is yesterday or earlier
            if (Object.keys(this.props.summaryBlocks).length >= 1) {
                compliance.value =
                    completedBlocksCount + '/' + session.totalBlocks;
                compliance.completedAthleteCount = 1;
                if (percentage < 50) {
                    compliance.color = 'red';
                } else {
                    compliance.color = 'green';
                }
                if (percentage === 100) {
                    compliance.icon = Icon.getIcon(Icon.TYPE.PIE100, 'green');
                } else if (percentage === 0) {
                    compliance.icon = Icon.getIcon(
                        Icon.TYPE.PIE0,
                        compliance.color
                    );
                } else {
                    let iconName = 'pie-' + this.getPieIconValue(percentage);
                    compliance.icon = Icon.getIcon(iconName, compliance.color);
                }
            } else {
                compliance.color = 'red';
                compliance.icon = Icon.getIcon(
                    Icon.TYPE.PIE0,
                    compliance.color
                );
                compliance.value = '0/' + session.totalBlocks;
            }
            //next case if it is future days
        } else if (
            sessionDate > today &&
            (Object.keys(this.props.summaryBlocks).length >= 1 &&
                completedBlocksCount >= 1)
        ) {
            compliance.completedAthleteCount = 1;
            compliance.value = completedBlocksCount + '/' + session.totalBlocks;
            if (percentage < 50) {
                compliance.color = 'black';
            } else {
                compliance.color = 'green';
            }
            if (percentage === 100) {
                compliance.icon = Icon.getIcon(Icon.TYPE.PIE100, 'green');
            } else if (percentage === 0) {
                compliance.icon = Icon.getIcon(
                    Icon.TYPE.PIE0,
                    compliance.color
                );
            } else {
                let iconName = 'pie-' + this.getPieIconValue(percentage);
                compliance.icon = Icon.getIcon(iconName, compliance.color);
            }
        }

        return compliance;
    }

    getPieIconValue(percentage) {
        if (percentage < 10) {
            return 10;
        } else if (percentage < 20) {
            return 10;
        } else if (percentage < 25) {
            return 30;
        } else if (percentage < 30) {
            return 30;
        } else if (percentage < 50) {
            return 30;
        } else if (percentage < 60) {
            return 50;
        } else if (percentage < 70) {
            return 60;
        } else if (percentage < 75) {
            return 60;
        } else if (percentage < 80) {
            return 75;
        } else if (percentage < 90) {
            return 80;
        } else if (percentage < 100) {
            return 90;
        } else {
            return 100;
        }
    }

    getComplianceTeam() {
        let session = this.props.session;
        let summary = this.props.summary;

        let sessionDate = new Date(
            session.year,
            session.month - 1,
            session.day
        ).setHours(0, 0, 0, 0);
        let today = new Date().setHours(0, 0, 0, 0);

        let compliance = {
            color: '',
            icon: Icon.getIcon(Icon.TYPE.PIE0, 'black'),
            value: '-'
        };

        if (!summary) {
            return compliance;
        }
        compliance.completedAthleteCount = summary.completed_athlete_count;
        compliance.value =
            summary.completed_athlete_count + '/' + summary.total_athlete_count;
        let percentage = 0;
        if (summary.total_athlete_count > 0) {
            percentage = Math.round(
                (summary.completed_athlete_count /
                    summary.total_athlete_count) *
                    100
            );
        }

        if (sessionDate === today || sessionDate > today) {
            //if is today
            if (percentage < 50) {
                compliance.color = 'black';
            } else {
                compliance.color = 'green';
            }
        } else if (sessionDate < today) {
            if (percentage < 25) {
                compliance.color = 'red';
            } else if (percentage < 66) {
                compliance.color = 'yellow';
            } else {
                compliance.color = 'green';
            }
        }

        if (percentage === 100) {
            compliance.icon = Icon.getIcon(Icon.TYPE.PIE100, 'green');
        } else if (percentage === 0) {
            compliance.icon = Icon.getIcon(Icon.TYPE.PIE0, compliance.color);
        } else {
            let iconName = 'pie-' + this.getPieIconValue(percentage);
            compliance.icon = Icon.getIcon(iconName, compliance.color);
        }

        return compliance;
    }

    round(value, precision) {
        return Number(Math.round(value + 'e' + precision) + 'e-' + precision);
    }

    getReadinessSingle() {
        let summarySession = this.props.summarySession;
        let readiness = {
            color: '',
            icon: Icon.getIcon(Icon.TYPE.JUICE0, 'black'),
            value: '-'
        };

        if (summarySession && summarySession.readiness) {
            readiness.value = summarySession.readiness;
            if (summarySession.readiness < 2.0) {
                readiness.color = 'red';
            } else if (summarySession.readiness < 3.0) {
                readiness.color = 'yellow';
            } else if (summarySession.readiness < 6.0) {
                readiness.color = 'green';
            }
            let readinessInteger = Math.round(summarySession.readiness);
            readiness.icon = Icon.getIcon(
                'juice-' + readinessInteger,
                readiness.color
            );
            if (
                readiness.value !== '' ||
                readiness.value !== null ||
                readiness.value !== '-'
            ) {
                if (/\./.test('' + readiness.value)) {
                    readiness.value = this.round(readiness.value, 2);
                }
            }
        }
        return readiness;
    }

    getReadinessTeam() {
        let summary = this.props.summary;
        let readiness = {
            color: '',
            icon: Icon.getIcon(Icon.TYPE.JUICE0, 'black'),
            value: '-'
        };

        if (summary && summary.avg_readiness !== null) {
            readiness.value = summary.avg_readiness;
            if (summary.avg_readiness < 2.0) {
                readiness.color = 'red';
            } else if (summary.avg_readiness < 3.0) {
                readiness.color = 'yellow';
            } else if (summary.avg_readiness < 6.0) {
                readiness.color = 'green';
            }
            let readinessInteger = Math.round(summary.avg_readiness);
            readiness.icon = Icon.getIcon(
                'juice-' + readinessInteger,
                readiness.color
            );
            if (
                readiness.value !== '' ||
                readiness.value !== null ||
                readiness.value !== '-'
            ) {
                if (/\./.test('' + readiness.value)) {
                    readiness.value = this.round(readiness.value, 2);
                }
            }
        }
        return readiness;
    }

    getDurationSingle() {
        let summarySession = this.props.summarySession;
        let duration = {
            color: '',
            icon: Icon.getIcon(Icon.TYPE.CLOCK, 'black'),
            value: '-'
        };
        if (summarySession && summarySession.session_duration > 0) {
            duration.icon = Icon.getIcon(Icon.TYPE.CLOCK);
            duration.value = summarySession.session_duration;
            if (
                duration.value !== '' ||
                duration.value !== null ||
                duration.value !== '-'
            ) {
                if (/\./.test('' + duration.value)) {
                    duration.value = this.round(duration.value, 0);
                }
            }
        }

        return duration;
    }

    getDurationTeam() {
        let summary = this.props.summary;
        let duration = {
            color: '',
            icon: Icon.getIcon(Icon.TYPE.CLOCK, 'black'),
            value: '-'
        };
        if (summary && summary.avg_session_duration > 0) {
            duration.icon = Icon.getIcon(Icon.TYPE.CLOCK);
            duration.value = summary.avg_session_duration;
            if (/\./.test('' + duration.value)) {
                duration.value = this.round(duration.value, 0);
            }
        }

        return duration;
    }

    getRPESingle() {
        let summarySession = this.props.summarySession;
        let rpe = {
            color: '',
            icon: Icon.getIcon(Icon.TYPE.INTENSITY0, 'black'),
            value: '-'
        };

        if (summarySession && summarySession.rpe > 0) {
            rpe.value = summarySession.rpe;
            if (summarySession.rpe < 4) {
                rpe.color = 'green';
            } else if (summarySession.rpe < 8) {
                rpe.color = 'yellow';
            } else if (summarySession.rpe < 11) {
                rpe.color = 'red';
            }
            let numIndex = Math.round(summarySession.rpe);
            rpe.icon = Icon.getIcon('intensity-' + numIndex, rpe.color);

            if (rpe.value !== '' || rpe.value !== null || rpe.value !== '-') {
                if (/\./.test('' + rpe.value)) {
                    rpe.value = this.round(rpe.value, 1);
                }
            }
        }
        return rpe;
    }

    getRPETeam() {
        let summary = this.props.summary;
        let rpe = {
            color: '',
            icon: Icon.getIcon(Icon.TYPE.INTENSITY0, 'black'),
            value: '-'
        };
        if (summary && summary.avg_rpe > 0) {
            rpe.value = summary.avg_rpe;
            if (summary.avg_rpe < 4) {
                rpe.color = 'green';
            } else if (summary.avg_rpe < 8) {
                rpe.color = 'yellow';
            } else if (summary.avg_rpe < 11) {
                rpe.color = 'red';
            }
            let numIndex = Math.round(summary.avg_rpe);
            rpe.icon = Icon.getIcon('intensity-' + numIndex, rpe.color);
            if (rpe.value !== '' || rpe.value !== null || rpe.value !== '-') {
                if (/\./.test('' + rpe.value)) {
                    rpe.value = this.round(rpe.value, 1);
                }
            }
        }

        return rpe;
    }

    getSessionConfig = () => {
        let sessionConfig = {
            status: {
                published: false,
                scheduled: false,
                isFuture: false,
                isToday: false,
                showSummary: false
            }
        };

        const { session, programType } = this.props;

        if (session.published) {
            sessionConfig.status.published = true;

            if (ProgramTypes.isTeamCalendar(programType)) {
                sessionConfig.status.fillColorClass = 'green-fill';
                sessionConfig.compliance = this.getComplianceTeam();
                sessionConfig.readiness = this.getReadinessTeam();
                sessionConfig.duration = this.getDurationTeam();
                sessionConfig.rpe = this.getRPETeam();
            } else if (ProgramTypes.isCoachAthleteCalendar(programType)) {
                sessionConfig.status.fillColorClass = 'green-fill';
                sessionConfig.compliance = this.getComplianceSingle();
                sessionConfig.readiness = this.getReadinessSingle();
                sessionConfig.duration = this.getDurationSingle();
                sessionConfig.rpe = this.getRPESingle();
            } else if (ProgramTypes.isInvitedAthleteCalendar(programType)) {
                sessionConfig.status.fillColorClass = 'green-fill';
            }
        } else {
            if (this.props.isPubEnabled) {
                let publishDate = Utils.calculatePublishDate(
                    session,
                    this.props.pubDays,
                    this.props.pubTime
                );
                sessionConfig.status.scheduled = true;
                sessionConfig.status.publishDate = publishDate;
                sessionConfig.status.fillColorClass = 'yellow-fill';
            } else {
                sessionConfig.status.fillColorClass = '';
            }
        }

        let sessionDate = new Date(
            session.year,
            session.month - 1,
            session.day
        ).setHours(0, 0, 0, 0);
        let today = new Date().setHours(0, 0, 0, 0);

        const sessionIsCompleted =
            sessionConfig.compliance &&
            sessionConfig.compliance.completedAthleteCount > 0;

        const sessionDateIsPassed =
            sessionDate === today || sessionDate < today;

        if (
            session.published &&
            !ProgramTypes.isInvitedAthleteCalendar(programType) &&
            (sessionDateIsPassed || sessionIsCompleted)
        ) {
            sessionConfig.status.showSummary = true;
            sessionConfig.status.fillColorClass = 'grey-fill';
        }

        return sessionConfig;
    };

    getSummaryLastActivity(summary, summarySession) {
        if (
            summarySession &&
            summarySession.lastActivity &&
            summarySession.lastActivity !== null
        ) {
            return summarySession.lastActivity;
        }

        if (summary && summary.lastActivity && summary.lastActivity !== null) {
            return summary.lastActivity;
        }

        return null;
    }

    getLastCommentContainer() {
        const summarySession = this.props.summarySession;
        const summary = this.props.summary;

        const lastActivity = this.getSummaryLastActivity(
            summary,
            summarySession
        );

        let lastCommentContainer = null;
        if (lastActivity) {
            let comment = lastActivity;
            if (lastActivity.replies.length > 0) {
                comment = lastActivity.replies[lastActivity.replies.length - 1];
            }

            lastCommentContainer = (
                <div>
                    <div className="see-more">View All Comments</div>
                    <CommentBubble comment={comment} />
                </div>
            );
        }

        return lastCommentContainer;
    }

    showFeedDrawer() {
        const { id, title, date, date_rescheduled } = this.props.session;
        const programWorkoutId = id;
        const teamId = this.props.team.group_id;

        getStore().dispatch(
            openCalendarMessagingSummaryDrawer(
                programWorkoutId,
                teamId,
                title,
                date_rescheduled || date
            )
        );

        return;
    }

    getSummaryCard(sessionConfig) {
        let surveysEnabled = true;
        let lastCommentContainer = this.getLastCommentContainer();
        this.onClick = () => {};
        let compliance = null;
        let cReadiness =
            sessionConfig.readiness &&
            sessionConfig.readiness.color !== undefined
                ? sessionConfig.readiness
                : false;
        let cDuration =
            sessionConfig.duration && sessionConfig.duration.color !== undefined
                ? sessionConfig.duration
                : false;
        let cRpe =
            sessionConfig.rpe && sessionConfig.rpe.color !== undefined
                ? sessionConfig.rpe
                : false;
        let cCompliance =
            sessionConfig.compliance &&
            sessionConfig.compliance.color !== undefined
                ? sessionConfig.compliance
                : false;

        const canShowFeedDrawer =
            ProgramTypes.isCoachAthleteCalendar(this.props.programType) ||
            ProgramTypes.isTeamCalendar(this.props.programType);

        if (canShowFeedDrawer && cCompliance) {
            this.onClick = ev => {
                this.showFeedDrawer(ev);
            };
            compliance = (
                <div className="summary-info layout-column">
                    <div className={'summary-icon ' + cCompliance.color}>
                        <Tooltip title="Compliance">
                            <span data-for="compliance">
                                {cCompliance.icon}
                            </span>
                        </Tooltip>
                    </div>
                    <div className="summary-value">{cCompliance.value}</div>
                    <div className="summary-label">Blocks</div>
                </div>
            );
        }

        let surveys = null;
        if (surveysEnabled && cReadiness) {
            surveys = (
                <div className="summary-info layout-column">
                    <div className={'summary-icon ' + cReadiness.color}>
                        <Tooltip title="Readiness">
                            <span data-for="readiness">{cReadiness.icon}</span>
                        </Tooltip>
                    </div>
                    <div className="summary-value">{cReadiness.value}</div>
                    <div className="summary-label">Readiness</div>
                </div>
            );
        }

        let durationBlock = null;
        if (cDuration) {
            durationBlock = (
                <div className="summary-info layout-column">
                    <div className={'summary-icon ' + cDuration.color}>
                        <Tooltip title="Duration">
                            <span data-for="duration">{cDuration.icon}</span>
                        </Tooltip>
                    </div>
                    <div className="summary-value">{cDuration.value}</div>
                    <div className="summary-label">Minutes</div>
                </div>
            );
        }

        let rpeBlock = null;
        if (cRpe) {
            rpeBlock = (
                <div className="summary-info layout-column">
                    <div className={'summary-icon ' + cRpe.color}>
                        <Tooltip title="Intensity">
                            <span data-for="rpe">{cRpe.icon}</span>
                        </Tooltip>
                    </div>
                    <div className="summary-value">{cRpe.value}</div>
                    <div className="summary-label">Intensity</div>
                </div>
            );
        }

        const summaryClasses =
            'summary-box layout-row layout-align-space-around-center grey-fill';
        let summaryBody = (
            <div className="summary-card">
                <div className={summaryClasses}>
                    {compliance}
                    {surveys}
                    {durationBlock}
                    {rpeBlock}
                </div>
                {lastCommentContainer}
            </div>
        );

        if (this.props.inDrawer) {
            return summaryBody;
        }

        if (canShowFeedDrawer) {
            return (
                <ButtonBase focusRipple onClick={this.onClick}>
                    {summaryBody}
                </ButtonBase>
            );
        }

        return <div>{summaryBody}</div>;
    }

    getStatusCard(sessionConfig) {
        let publishStatus = <span className="status-text">UNPUBLISHED</span>;

        if (sessionConfig.status.published) {
            publishStatus = <span className="status-text">PUBLISHED</span>;
        } else if (sessionConfig.status.scheduled) {
            publishStatus = (
                <span className="status-text">
                    SCHEDULED {sessionConfig.status.publishDate}
                </span>
            );
        }

        const status = <div className="publish-status">{publishStatus}</div>;
        const canShowFeedDrawer =
            ProgramTypes.isCoachAthleteCalendar(this.props.programType) ||
            ProgramTypes.isTeamCalendar(this.props.programType);

        if (canShowFeedDrawer && sessionConfig.status.published) {
            return (
                <ButtonBase
                    focusRipple
                    onClick={ev => {
                        this.showFeedDrawer(ev);
                    }}
                >
                    {status}
                </ButtonBase>
            );
        }

        return status;
    }

    getCollapsedStatusIcon(sessionConfig) {
        let publishStatusIcon = null;
        if (sessionConfig.status.published) {
            publishStatusIcon = <CheckIcon className="status-icon" />;
        } else if (sessionConfig.status.scheduled) {
            publishStatusIcon = <ClockIcon className="status-icon" />;
        } else {
            publishStatusIcon = <UnpublishedIcon className="status-icon" />;
        }

        return publishStatusIcon;
    }

    render() {
        Console.render('SummaryHeader');
        const { programType, session } = this.props;
        if (!session || ProgramTypes.isProgram(programType)) {
            return null;
        }

        let sessionConfig = this.getSessionConfig();
        let header = null;
        if (
            sessionConfig.status.showSummary &&
            !ProgramTypes.isCalendar(programType) &&
            !ProgramTypes.isInvitedAthleteCalendar(programType)
        ) {
            header = this.getSummaryCard(sessionConfig);
        } else {
            header = this.getStatusCard(sessionConfig);
        }

        let statusIcon = this.getCollapsedStatusIcon(sessionConfig);

        return (
            <div
                className={
                    'summary-header ' + sessionConfig.status.fillColorClass
                }
            >
                {header}
                {statusIcon}
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    let summary = null;
    let summarySession = null;
    if (ownProps.session) {
        summary = state.summary.summaryTree[ownProps.session.workout_id];
        summarySession =
            state.summary.calendarSummarySessionTree[
                ownProps.session.workout_id
            ];
    }

    return {
        summary: summary,
        summarySession: summarySession,
        calendarInstructionsEnabled:
            state.calendar.uiTree.calendarInstructionsEnabled,
        blocks: state.calendar.blockTree,
        summaryBlocks: state.summary.calendarSummaryBlockTree,
        summaryExercises: state.summary.calendarSummaryExerciseTree,
        currentUserId: state.calendar.uiTree.currentUser,
        summaryFeedProgram: state.feed.feedData.summaryFeedProgram,
        isPubEnabled: state.calendar.infoTree.team.pub_enabled === 1,
        pubDays: state.calendar.infoTree.team.pub_days,
        pubTime: state.calendar.infoTree.team.pub_time,
        team: state.calendar.infoTree.team,
        programType: state.calendar.infoTree.programType,
        userPrefs: state.app.userPrefs,
        ...ownProps
    };
};

export default connect(mapStateToProps)(SummaryHeaderClass);
